import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Tracks the last visited non-auth URL in sessionStorage.
 * This allows the AuthContext to redirect the user back to where 
 * they were before they hit the login/signup flow.
 */
const AuthRedirectTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // List all paths that should NOT be saved as a "return destination"
    const authPaths = [
      '/signin', 
      '/signup', 
      '/business/login', 
      '/business/signin', 
      '/business/signup' // handles trailing slashes
    ];
    
    const currentPath = location.pathname + location.search;

    // Only update storage if the current page is NOT an auth page
    const isAuthPath = authPaths.some(path => location.pathname === path);

    if (!isAuthPath) {
      // console.log("📍 Tracking last valid URL:", currentPath);
      sessionStorage.setItem("last_valid_url", currentPath);
    }
  }, [location]);

  return null; 
};

export default AuthRedirectTracker;